import { useAuth } from '../../contexts/AuthContext.jsx';
import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../api/client.js';

/**
 * Read-only organization summary today. Editing org name / slug lands
 * with the per-org settings ADR — owner-only mutations, slug changes
 * cascade to login redirect, etc.
 */
export default function Organization() {
  const { organization } = useAuth();

  // Light request for org membership count + project count (cheap aggregates).
  const q = useQuery({
    queryKey: ['org-summary'],
    queryFn: ({ signal }) => apiGet('/organization', { signal }),
    retry: false,
  });

  return (
    <div className="account-page">
      <header className="account-page-head">
        <h1>Organization</h1>
        <p className="muted">The tenant that owns every project, post, and connected account in this Markaii install.</p>
      </header>

      <section className="account-section">
        <h2>Identity</h2>
        <div className="kv">
          <div className="kv-row"><span className="kv-label">Name</span><pre>{organization?.name}</pre></div>
          <div className="kv-row"><span className="kv-label">Slug</span><pre>{organization?.slug}</pre></div>
          <div className="kv-row"><span className="kv-label">Your role</span><pre>{organization?.role}</pre></div>
        </div>
      </section>

      {q.data && (
        <section className="account-section">
          <h2>At a glance</h2>
          <div className="org-stat-grid">
            <div className="org-stat">
              <span className="org-stat-val">{q.data.member_count}</span>
              <span className="org-stat-lbl">member{q.data.member_count === 1 ? '' : 's'}</span>
            </div>
            <div className="org-stat">
              <span className="org-stat-val">{q.data.project_count}</span>
              <span className="org-stat-lbl">project{q.data.project_count === 1 ? '' : 's'}</span>
            </div>
            <div className="org-stat">
              <span className="org-stat-val">{q.data.post_count}</span>
              <span className="org-stat-lbl">post{q.data.post_count === 1 ? '' : 's'}</span>
            </div>
            <div className="org-stat">
              <span className="org-stat-val">{q.data.social_account_count}</span>
              <span className="org-stat-lbl">social account{q.data.social_account_count === 1 ? '' : 's'}</span>
            </div>
          </div>
        </section>
      )}

      <section className="account-section">
        <h2>Settings</h2>
        <p className="muted small">
          Renaming the organization, changing its slug, or transferring ownership
          land with a dedicated audit-trail flow — see the queued ADR-0008. For
          now, contact ops to make those changes.
        </p>
      </section>
    </div>
  );
}
